'use strict'

export class SchedulePrepod
{
    constructor()
    {
        this.init()
    }

    init()
    {
        const self = this


        $(document).on('click', '.js-checkout-action-teacher', function(e){
            console.log(e);
            e.preventDefault()
            let elem = $(this)
            let id = elem.parents('.card-item-id').data('id')

            $.ajax({
                url: '/local/ajax/element.php',
                method: 'POST',
                data: {elem: id}
            }).done(function(e){
                $.fancybox.open(e)
            })
        })

        $(document).on('submit', 'form.order', function(e){
            e.preventDefault()
            self.sendForm($(this), false)
        })

        $(document).on('click', '.js-submit-similar', function(e){
            e.preventDefault()
            let form = $(this).parents('form')
            self.sendForm(form, false)
        })

        $(document).on('click', '.js-submit-online', function(e){
            e.preventDefault()
            let form = $(this).parents('form')
            form.find('[name="payment"]').val('10')
            self.sendForm(form, true)
        })

        $(document).on('change', '#step1 select', function(){
            $('.js-inner-datetime').html($(this).val());
        })
    }

    sendForm($form, redirect = false)
    {
        var data = $form.serialize();

        $.ajax({
            url: '/local/ajax/order.php',
            method: 'POST',
            data: data
        }).done(function(e){
            let json = JSON.parse(e);
            if (redirect === true) {
                window.location = '/catalog/payment.php?ORDER_ID='+json.id
            }
            $('#step4-nav').tab('show');
        })

        return false
    }
}
